import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-127" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-128" data-mp="1mo2182j7gpfa">
        <h2 className="text-center text-2xl font-bold leading-tight tracking-tight text-stone-900 sm:text-3xl" data-id="element-129" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-130" data-mp="1hqinr4uc0goe">🏆 </span>Special Launch Offer
        </h2>

        <div className="relative mt-10 rounded-xl border-2 border-orange-600 bg-white px-7 pb-8 pt-11" data-id="element-131" data-mp="tzd92t04nufo">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-orange-600 px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-132" data-mp="p1bizo4aauup">
            Math Ready Pack
          </span>

          <dl data-id="element-133" data-mp="z010hfs9qdaf">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between border-b border-stone-200 py-4 text-sm" data-id="element-134" data-mp="2fb4zqunvt05j">
                <dt className="text-stone-700" data-id="element-135" data-mp="pkh5x9amssf5">{row.label}</dt>
                <dd className="font-semibold text-orange-600" data-id="element-136" data-mp="pjyz5iqcevsz">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-stone-200 py-4 text-sm" data-id="element-137" data-mp="ul4wjtuy778u">
              <dt className="font-semibold uppercase tracking-wide text-stone-900" data-id="element-138" data-mp="zgk98ih7yx3o">
                Total Value:
              </dt>
              <dd className="font-semibold text-stone-500 line-through" data-id="element-139" data-mp="6u95x028ai36">
                $212 USD
              </dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-bold uppercase tracking-[0.16em] text-orange-600" data-id="element-140" data-mp="bt2eqf6klkx0">
            Today only
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-stone-200 pb-7 pt-2" data-id="element-141" data-mp="klntlk72z7gk">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-142" data-mp="3k95gy5ewyhdy">
              🏆
            </span>
            <span className="text-6xl font-bold leading-none tracking-tight text-orange-600" data-id="element-143" data-mp="3o9fohmictfux">
              $27
            </span>
            <span className="self-end pb-2 text-sm font-semibold text-orange-600" data-id="element-144" data-mp="ve5ym1dkz9p2">
              USD
            </span>
          </p>

          <CtaButton className="mt-7 w-full" data-id="element-145" data-mp="155k6oxjllhtt" />

          <p className="mt-4 text-center text-[11px] font-medium text-stone-500" data-id="element-146" data-mp="1548tk749ixq1">
            Instant Download · One-Time Payment · Lifetime Access · 7-Day
            Guarantee
          </p>
        </div>
      </div>
    </section>;
}